import React, { useState, useEffect } from 'react'
import { useRouter } from 'next/router'
import { colors, fontSizes } from '@/theme'
import config from '@/utils/config'
import TextInput from '@/components/text-input';
import Helper from '@/utils/helper';
import * as Enums from '@/utils/enums';
import Button from '@/components/button';
import { createFileRoute } from '@tanstack/react-router'

function CompleteSignup() {
    const router = useRouter();
    const { t: resetToken, c: customerName, u: userName } = router.query; // TODO(tanstack-router): verify router.query → useParams/useSearch
    const registerSuccess = !!customerName;

    const [message, setMessage] = useState("");
    const [inputs, setInputs] = useState({
        password: "",
        mobileNumber: ""
    });
    const [errors, setErrors] = useState({
        password: null,
    });
    const [success, setSuccess] = useState<any>(null);
    const [submitting, setSubmitting] = useState(false);

    const validate = () => {
        let [isValid, newErrors] = Helper.validateInputsArrayOut([
            { passwordLength: 8, value: inputs.password, key: "password", required: true, type: Enums.ControlType.Text }
        ]);
        if(inputs.password.length > 100) {
            isValid = false;
            (newErrors as any).password = 'Please use a password of 100 characters or less';
        }
        setErrors((newErrors as any));
        return isValid;
    };

    const handleSubmit = async () => {

        if (!validate()) return;

        setSubmitting(true);

        const res = await fetch(config.managerHost + '/Authentication/PasswordInitialise', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'SC-Version': __APP_VERSION__
            },
            body: JSON.stringify({
                ResetToken: resetToken,
                Password: inputs.password,
                MobileNumber: inputs.mobileNumber
            })
        });

        const data = await res.text();
        const json = (data.length ? JSON.parse(data) : {});

        if (res.ok) {
            setMessage("");
            setSuccess(true);
        } else if (json && json.Message) {
            setMessage(`Failed to update your password. Reason: ${json.Message}`);
        } else if (json) {
            setMessage(`Failed to update your password. ${json}`);
            setSuccess(false);
        } else if (data) {
            setMessage(`Failed to update your password. ${json}`);
            setSuccess(false);
        }

        setSubmitting(false);
    };

    const inputUpdated = (e: any) => {
        setInputs({
            ...inputs,
            [e.target.name]: e.target.value
        });
        setErrors({
            ...errors,
            [e.target.name]: null
        });
    };

    const updatePasswordClicked = () => {
        handleSubmit();
    }

    return (
        <div className="login">
            <div className="container">
                <img src="/logo-type-blue.svg" alt="Login Logo" />
                {registerSuccess ? <>
                    {resetToken ? <>
                        <h1>Thank you for registering your new account</h1>

                        <h1 className="id-class">{customerName}</h1>
                        <h1 className="id-class">{userName}</h1>

                        <p>Please set your password below for your first time logging in</p>

                        <div className="less-width">
                            <TextInput
                                label="Password"
                                type="password"
                                value={inputs.password}
                                name="password"
                                error={errors.password}
                                changeHandler={inputUpdated}
                                required={true}
                            />

                            <TextInput
                                label="Mobile Number"
                                type="text"
                                value={inputs.mobileNumber}
                                name="mobileNumber"
                                placeholder={"(000) 000-0000"}
                                error={(errors as any).mobileNumber}
                                changeHandler={inputUpdated}
                            />

                            <Button
                                text={success === true ? "Password Set" : submitting === true ? "Setting Password" : "Set Password"}
                                onClick={updatePasswordClicked}
                                disabled={submitting === true || success === true}
                            />
                        </div>

                        <h2 className={`error ${success !== false ? "" : "error-display"}`}>{message}</h2>
                        {success === true ? <>
                            <h2>You have successfully set your password. Proceed to <a className="link" href="/login?redirect=/settings/integration/manage">login page</a>.</h2>
                        </> : <p>You can also request your first time password on our <a className="link" href="/login">login page</a>.</p>}
                    </> : <>
                        <h1>An account for {customerName} already exists.</h1>
                        <h2>Proceed to <a className="link" href="/login">login page</a>.</h2>
                    </>}
                </> : <>
                    <h1>Something went wrong when registering your new account.</h1>
                    <br /><br />
                    <h2>Please try again or register for your free trial at <a target="_blank" href="https://www.servcraft.co.za/free-trial">servcraft.co.za</a> </h2>
                </>}

                <img className="wave" src="/login-wave.svg" alt="Login Wave" />
            </div>
            <style jsx>{`
        .login {
          display: flex;
          height: 100vh;
          justify-content: center;
          overflow: hidden;
          position: relative;
          width: 100%;
        }
        .container {
          color: #333;
          text-align: center;
          width: 310px;
        }
    
        img {
          padding-top: 3.5rem;
        }
        h1 {
          color: ${colors.blueGrey};
          font-size: 24px;
          margin: 0;
          padding-top: 1.5rem;
        }
        h2 {
          color: ${colors.darkPrimary};
          font-size: 24px;
          margin: 0;
          padding-top: 1.5rem;
        }
        p {
          color: ${colors.blueGrey};
          font-size: ${fontSizes.body};
          margin: 0;
          padding-bottom: 1rem;
          padding-top: 0.5rem;
        }
        .wave {
          bottom: 0;
          pointer-events: none;
          left: 0;
          min-width: 1300px;
          position: absolute;
          width: 100vw;
          z-index: -1;
        }
        .row {
          align-items: center;
          display: flex;
          justify-content: space-between;
          margin-top: 1rem;
        }
        .center {
          justify-content: center;
        }
        .end {
          justify-content: flex-end;
        }
        .row a,.row-center a {
          color: ${colors.bluePrimary};
          cursor: pointer;
          font-size: 0.875rem;
        }
        .error {
          color: ${colors.warningRed};
          display: none;
        }
        .error-display {
          display: block;
        }

        .link {
            color: ${colors.bluePrimary};
        }

        .id-class {
            margin: 0px;
            font-size: 1.2rem;
            padding-top: 8px;
        }
      `}</style>
        </div>
    );
}

export default CompleteSignup;

export const Route = createFileRoute('/complete-signup')({ component: CompleteSignup })
